<form [formGroup]="form">
  <div class="gap-lg grid" formArrayName="caracteristiques">
    @for (form of caracteristiques.controls; track $index; let idx = $index) {
      <div [formGroupName]="idx" hlmField>
        <label [for]="'nom-' + idx" hlmFieldLabel labelRequired>Nom de la caractéristique {{ idx + 1 }}</label>
        <input [id]="'nom-' + idx" hlmInput type="text" formControlName="nom" />
        @if (form.get('nom')?.hasError('required') && form.touched) {
          <hlm-field-error>Merci de renseigner un nom</hlm-field-error>
        }
        @if (form.get('nom')?.hasError('notUnique')) {
          <hlm-field-error>Cette caractéristique existe déjà.</hlm-field-error>
        }
      </div>
    }
    <app-button-add-new (click)="addCaracteristique()" label="Ajouter une autre caractéristique" />
  </div>
</form>
